export class ObjUtil {
  clone(obj) {
    return Object.assign(new (obj.constructor)(), obj)
  }
  copy(obj) {
    return Object.assign({}, obj)
  }
  setdefault(dict, key, value) {
    if (key in dict) {
      return dict[key]
    } else {
      dict[key] = value
      return value
    }
  }
  get(object, key, default_value) {
    if (!object) return default_value
    var result = object[key];
    return (typeof result !== "undefined") ? result : default_value;
  }
  isEmpty(obj) {
    if (!obj) return true
    if (typeof obj === 'object') {
      return Object.keys(obj).length === 0
    }
    return false
  }
  has(obj, key) {
    return obj.hasOwnProperty(key)
  }
}

export var objUtil = new ObjUtil()



// WEBPACK FOOTER //
// ./src/plugins/jscom/jscom/utils/objutil.js